var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlugOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2496 1V5.18934L13.439 7H6.99962V11.5C6.99962 12.0763 7.10794 12.6272 7.30533 13.1336L6.17687 14.2621C5.74461 13.4324 5.50123 12.4917 5.49962 11.5V7C5.49962 6.17157 6.1712 5.5 6.99962 5.5H7.74962V1H9.24962V5.5H13.7496V1H15.2496ZM8.10112 16.4386L4.19347 20.3463L3.13281 19.2856L19.8211 2.59728L20.8818 3.65794L17.4996 7.04011V11.5C17.4947 14.5209 15.2466 17.068 12.2496 17.448V22H10.7496V17.448C9.76922 17.3237 8.86895 16.9675 8.10112 16.4386ZM9.18179 15.3579C9.85877 15.7655 10.6518 16 11.4996 16C13.9849 16 15.9996 13.9853 15.9996 11.5V8.54011L9.18179 15.3579Z",
    fill: "#E20074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugOff);
export default __webpack_public_path__ + "static/media/plug_off.3fba8be29cd7e0d6ef47b2c91b44a997.svg";
export { ForwardRef as ReactComponent };